import { pageTitleStyles } from "@insite/content-library/Widgets/ProductDetails/ProductDetailsPageTitle";
import { css } from "styled-components";

pageTitleStyles.titleText = {
    variant: "h2",
    css: css`
        font-weight: 700;
        font-size: 30px;
        text-transform: capitalize;
        color: #333;
    `,
};
